import { useQuery } from '@tanstack/react-query';
import { fetchAllPages } from '../api/paging';
import type { AllergenOptionResponse } from '../api/types';
import { useApi } from '../auth/ApiProvider';
import { normalizeAllergenName } from './normalize';

/** An allergen of the catalogue, with every name it is matched by already folded by `normalizeAllergenName`. */
export interface CatalogueEntry {
  option: AllergenOptionResponse;
  names: string[];
}

/**
 * The platform's allergen catalogue as the allergy editor offers it (Q75): the same for every nursery, and changed by
 * the platform a few times a year, so it is read once and kept, its names folded once with it rather than by every
 * field that reads it.
 */
export function useAllergenCatalogue() {
  const api = useApi();
  return useQuery({
    queryKey: ['allergens', 'catalogue'],
    staleTime: 30 * 60_000,
    queryFn: async (): Promise<CatalogueEntry[]> =>
      (await fetchAllPages((page) => api.allergens.list({ page, pageSize: 100 }))).map((option) => ({
        option,
        names: [option.nameAr, option.nameEn, ...option.names].map(normalizeAllergenName),
      })),
  });
}
